/**
 * Returns the total number of notifications for a given tenant.
 * This includes RecordComments notifications.
 */
export function GetTotalNotificationsFromTenant(tenantID: string, user: any) {
  // For those clouase with staled number notifications.
  if (typeof user?.Notifications?.[tenantID] === "number")
    return user?.Notifications?.[tenantID];

  const keys = Object.keys(user?.Notifications?.[tenantID] ?? {});

  if (!keys.length) return 0;

  return keys.reduce((acc, currentKey) => {
    if (currentKey === "RecordComments") {
      return (
        acc +
        GetTotalRecordCommentsNotifications(
          user?.Notifications[tenantID][currentKey]
        )
      );
    } else {
      return acc;
    }
  }, 0);
}

/**
 * Calculates the total number of RecordComments notifications.
 */
function GetTotalRecordCommentsNotifications(recordComments: {
  [key: string]: number;
}) {
  const totalRecordCommentNotifications = Object.keys(recordComments).reduce(
    (acc, recordIDKey) => {
      return acc + recordComments[recordIDKey];
    },
    0
  );

  return totalRecordCommentNotifications ?? 0;
}
